import { render } from "./MenuPlayer.vue?vue&type=template&id=a69d2f04&scoped=true"
import script from "./MenuPlayer.vue?vue&type=script&lang=js"
export * from "./MenuPlayer.vue?vue&type=script&lang=js"

import "./MenuPlayer.vue?vue&type=style&index=0&id=a69d2f04&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a69d2f04"]])

export default __exports__